import { render, staticRenderFns } from "./OrganizationServiceExam.vue?vue&type=template&id=dbacd41a&scoped=true&"
import script from "./OrganizationServiceExam.vue?vue&type=script&lang=js&"
export * from "./OrganizationServiceExam.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationServiceExam.vue?vue&type=style&index=0&id=dbacd41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbacd41a",
  null
  
)

export default component.exports